module.exports = __webpack_public_path__ + "static/media/paypal.bbf94cdb.svg";